export default "__VITE_ASSET__716a8c47__"